import { render, staticRenderFns } from "./ReturnForm.vue?vue&type=template&id=661ff46a&scoped=true&"
import script from "./ReturnForm.vue?vue&type=script&lang=ts&"
export * from "./ReturnForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnForm.vue?vue&type=style&index=0&id=661ff46a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ff46a",
  null
  
)

export default component.exports